// @flow
import {type PaymentMethodsType} from './paymentMethodsType';

export const initialState = {
    status: 'pending',
    list: {},
};

/**
 *  Payment Methods
 * @param {PaymentMethodsType} state Current state
 * @param {action} action Received action
 * @returns {PaymentMethodsType} Payment Methods werwe
 */
export default function PaymentMethods(
    state: PaymentMethodsType = initialState,
    action: {type: string, payload: any},
): PaymentMethodsType {
    switch (action.type) {
        case 'GET_PAYMENT_METHODS_PENDING':
            return {status: 'pending', list: {}};
        case 'GET_PAYMENT_METHODS_FULFILLED':
            return {status: 'fulfilled', list: action.payload.data};
        default:
            return state;
    }
}
